import classNames from 'classnames';
import PropTypes from 'prop-types';

import { Button } from '@ctct/ui-react';

import PriceContainer from './PriceContainer';

function getButtonKind(isCurrent, isRecommended, isSelected) {
  if (isCurrent) {
    return 'white';
  }

  if (!isRecommended || isSelected) {
    return 'secondary';
  }

  return 'primary';
}

const ComparisonTableHead = ({ plans }) => {
  return (
    <thead>
      <tr>
        <th />
        {plans.map((plan) => (
          <th key={plan.planId} className={classNames(plan.isRecommended && 'recommended')}>
            <h4 className="plan-name-label">{plan.planNameLabel}</h4>
            <PriceContainer price={plan.price} />
            {!plan.buttonHidden && (
              <div>
                <Button
                  className={classNames(plan.isSelected && 'btn-plan-selected')}
                  kind={getButtonKind(plan.isCurrent, plan.isRecommended, plan.isSelected)}
                  shape="pill"
                  size="small"
                  onClick={plan.buttonClickHandler}
                  glyph={plan.isSelected ? 'checkCircleFilled' : ''}
                  text={plan.buttonLabel}
                  disabled={plan.buttonDisabled}
                />
              </div>
            )}
          </th>
        ))}
      </tr>
    </thead>
  );
};

ComparisonTableHead.propTypes = {
  plans: PropTypes.arrayOf(
    PropTypes.shape({
      planId: PropTypes.number.isRequired,
      planNameId: PropTypes.string.isRequired,
      planNameLabel: PropTypes.string.isRequired,
      isSelected: PropTypes.bool.isRequired,
      isRecommended: PropTypes.bool.isRequired,
      isCurrent: PropTypes.bool.isRequired,
      price: PropTypes.shape({
        paymentPeriodLabel: PropTypes.string.isRequired,
        planCurrency: PropTypes.string.isRequired,
        planFullPrice: PropTypes.number.isRequired,
        planPriceDiscounted: PropTypes.number,
        isUpdatingCurrency: PropTypes.bool.isRequired,
        showDecimals: PropTypes.bool.isRequired,
      }),
      buttonLabel: PropTypes.string.isRequired,
      buttonClickHandler: PropTypes.func.isRequired,
      buttonDisabled: PropTypes.bool.isRequired,
      buttonHidden: PropTypes.bool.isRequired,
    })
  ).isRequired,
};

export default ComparisonTableHead;
